import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';

export const transformEditDataControl = (
  modelEventoDTO: ModelEventoDTO
): AccordionEditDataControl => {
  return {
    dateValidity: modelEventoDTO.datiEventoUnioneCivile?.dataEvento
      ? DateTime.fromISO(modelEventoDTO.datiEventoUnioneCivile?.dataEvento)
      : DateTime.now(),
  };
};
